import React from 'react'
import welcomeimg from '../../../assets/welcome-banner.svg'
import { Link, useNavigate } from 'react-router-dom'
import { GLOBAL_STYLES } from '../../../appConstants'
import rightarrow from '../../../assets/rightarrow.svg';
import { useSignUpContext } from '../../../context/SignUpContext';
export default function WelcomeStep() {
    const { setSignUpDetails } = useSignUpContext()
    const navigate = useNavigate();
    return (
        <div className='w-full h-full flex flex-col justify-center items-center'>
            <div className='welcome_banner_image h-[300px] flex justify-center'>
                <img src={welcomeimg} width={"250px"} height={"250px"} alt='welcome_banner_image' />
            </div>
            <p className='text-[#1E1E1E] font-[700] font-manrope mt-1 mb-2'>Awesome!</p>
            <p className='text-[#3B3B3B] font-manrope font-[600] text-[14px]'>You’ve completed all signup steps. Your 15-day trial starts now!</p>

            <div onClick={() => {
                setSignUpDetails((prev) => ({
                    ...prev,
                    redirectLogin: true,
                }))
                navigate('/login');
            }} className='text-[14px] mt-10 cursor-pointer flex items-center gap-1 font-manrope font-[600] text-[#0F5EFF]'>
                {/* <img src={} alt={} /> */}
                <span>Go to Login</span>
                <img src={rightarrow} width={18} height={18} />
            </div>
        </div>
    )
}
